export const formatStartDate = (startDate) => {
  if (!startDate) return null;
  const date = new Date(startDate);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const daysUntil = (startDate) => {
  if (!startDate) return null;
  const start = new Date(startDate);
  if (Number.isNaN(start.getTime())) return null;
  const msPerDay = 24 * 60 * 60 * 1000;
  const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
  const now = new Date();
  const nowUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const diff = Math.ceil((startUtc - nowUtc) / msPerDay);
  return diff > 0 ? diff : null;
};

export const computeIsLocked = (courseRun) => {
  if (!courseRun) return false;
  const { startDate, isStarted } = courseRun;
  if (isStarted === false) return true;
  if (isStarted !== undefined) return false;
  if (!startDate) return false;
  const startTimestamp = new Date(startDate).getTime();
  if (Number.isNaN(startTimestamp)) return false;
  return startTimestamp > Date.now();
};
